/*
  Colour patch selection for product cards.
  Cards are moved around by Swiper, re-rendered by the collection tabs and
  replaced wholesale by the collection filters, so selection is handled by a
  single delegated listener rather than per-card binding.
*/
(function () {
  if (window.kgPcardSwatchesLoaded) return;
  window.kgPcardSwatchesLoaded = true;

  // Home/slider cards and PLP grid cards share the behaviour but not the markup.
  var CARD_TYPES = [
    {
      card: ".kg-pcard",
      swatch: ".kg-pcard__swatch",
      image: "img.kg-pcard__img--primary",
      activeClass: "is-active",
      atc: ".kg-pcard__atc"
    },
    {
      card: ".plp-card",
      swatch: ".plp-card__swatch-dot",
      image: "img.primary-image",
      activeClass: "is-selected",
      atc: ".plp-card__add-to-cart"
    }
  ];

  function setCardImage(card, type, url) {
    var img = card.querySelector(type.image);
    if (!img || !url) return;

    // lazysizes owns srcset/sizes once it has upgraded the image; clearing
    // srcset stops it from restoring the previous colour's source.
    img.removeAttribute("srcset");
    img.setAttribute("data-src", url);
    img.src = url;
  }

  function setCardVariant(card, type, variantId, available) {
    var idInput = card.querySelector('input[name="id"]');
    if (idInput && variantId) idInput.value = variantId;

    var atc = card.querySelector(type.atc);
    if (!atc) return;

    var soldOut = available === "false";
    var label = soldOut ? atc.getAttribute("data-label-soldout") : atc.getAttribute("data-label-available");

    atc.disabled = soldOut;
    if (label) {
      var labelTarget = atc.querySelector("[data-atc-label]") || atc;
      labelTarget.textContent = label;
    }
  }

  function selectSwatch(card, type, swatch) {
    var swatches = card.querySelectorAll(type.swatch);
    for (var i = 0; i < swatches.length; i++) {
      var isActive = swatches[i] === swatch;
      swatches[i].classList.toggle(type.activeClass, isActive);
      swatches[i].setAttribute("aria-pressed", isActive ? "true" : "false");
    }
  }

  document.addEventListener("click", function (event) {
    if (!(event.target instanceof Element)) return;

    for (var i = 0; i < CARD_TYPES.length; i++) {
      var type = CARD_TYPES[i];
      var swatch = event.target.closest(type.swatch);
      if (!swatch) continue;

      var card = swatch.closest(type.card);
      if (!card) continue;

      event.preventDefault();

      selectSwatch(card, type, swatch);
      setCardImage(card, type, swatch.getAttribute("data-variant-image"));
      setCardVariant(card, type, swatch.getAttribute("data-variant-id"), swatch.getAttribute("data-variant-available"));
      return;
    }
  });
})();
